import type { FeatureFlags } from '@puzzlio/core/featureFlags';

/*
  The flags /api/me last reported, kept in localStorage so a page can show flagged features before its
  own /api/me answers. They belong to whoever was signed in, so logging out clears them.
*/

const STORAGE_KEY = 'puzzlio_feature_flags';
const NONE: FeatureFlags = {};

let lastRaw: string | null = null;
let lastParsed: FeatureFlags = NONE;

/** The cached flags. The same object until the stored value changes, as useSyncExternalStore needs. */
export function readCachedFeatureFlags(): FeatureFlags {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(STORAGE_KEY);
  } catch {}
  if (raw !== lastRaw) {
    lastRaw = raw;
    try {
      lastParsed = raw ? (JSON.parse(raw) as FeatureFlags) : NONE;
    } catch {
      lastParsed = NONE;
    }
  }
  return lastParsed;
}

/** What the server renders with: it can't see the cache, so nothing is on until the page hydrates. */
export const serverFeatureFlags = () => NONE;

export function cacheFeatureFlags(flags: FeatureFlags) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(flags));
  } catch {}
}

export function clearCachedFeatureFlags() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
}
